export const CyTitleEditable = {
  SpanPlaylistTitle: "SpanPlaylistTitle",
} as const;
